import { URLASSOLUTO, URLASSOLUTOISTITUZIONALE, CURRENTROUTENAME, VIEWNAME, TEMPLATEID } from "./variables";
import Swal from "./sweetalert2";
import bootstrapvalidation from "./validate";
//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...

$(document).ready(function () {
    let hash = window.location.hash;

    if ($(hash + "L").length) {
        $("html, body").animate(
            {
                scrollTop: $(hash + "L").offset().top,
            },
            1000
        );
    }
    // fade out background preloader
    $("#preload").fadeOut(function () {
        $(".headerBottom").addClass("isvisible");
    });

    $("body").on("click", "#search-display", function () {
        $("#searchHeaderbox").toggleClass("d-none");
    });

    $("body").on("change", ".languageselector", function () {
        var languageselected = $(this).find(":selected").data("path");
        if (typeof languageselected !== "undefined") {
            window.location.href = languageselected;
        }
    });
    $("body").on("click", ".expandfilter", function () {
        $(this).closest(".filterblock").toggleClass("itemselectable");
    });

    $("body").on("click", ".buttoniniziaheader", function (e) {
        $("html, body").animate(
            {
                scrollTop: $(this).offset().top + $(this).height(),
            },
            1000
        );
    });

    $("body").on("click", ".recupera-password", function (e) {
        $(this).closest("form").removeClass("was-validated");
        $(".recupera-password-toggle").slideToggle();
        $(this).closest("form").find("#username").prop("required", false);
        $(this).closest("form").find("#password").prop("required", false);
        $(this).closest("form").find("#Email").prop("required", true);
    });

    $("body").on("change", ".check-spedizione", function (e) {
        if ($(this).is(":checked")) {
            $(".check-spedizione-toggle").fadeIn();
            $(".check-spedizione-toggle .required").prop("required", true);
        } else {
            $(".check-spedizione-toggle").fadeOut();
            $(".check-spedizione-toggle .required").prop("required", false);
        }
        $(this).closest("form").removeClass("was-validated");
    });

    $("body").on("click", ".click-spedizione", function (e) {
        $(this).closest("form").removeClass("was-validated");
        $(".click-spedizione-toggle").slideToggle();
        $(this)
            .closest("form")
            .find("input")
            .each(function (index) {
                if ($(this).is(":visible") && $(this).hasClass("required")) {
                    $(this).prop("required", true);
                } else {
                    $(this).prop("required", false);
                }
            });
    });

    $("body").on("click", ".non-registrato", function (e) {
        $(".non-registrato-toggle").slideToggle();
    });

    $("body").on("change", "#Azienda", function (e) {
        $(this).closest("form").removeClass("was-validated");
        var valAzienda = $(this).val();
        if (valAzienda == "1") {
            $(".check-azienda-show").parent().fadeIn();

            var labelchanged = "";
            $(".check-azienda").each(function (index) {
                $(this).prop("required", true);
                labelchanged = $(this).data("label");
                $(this)
                    .parent()
                    .find("label")
                    .html(labelchanged + " *");
            });
        } else {
            $(".check-azienda-show").parent().fadeOut();

            var labelchanged = "";
            $(".check-azienda").each(function (index) {
                $(this).prop("required", false);
                labelchanged = $(this).data("label");
                $(this).parent().find("label").html(labelchanged);
            });
        }
    });

    if ($(".cursorspecialpointer").length > 0) {
        $("body").mousemove(function (i) {
            var e = i.pageX - 8,
                t = i.pageY - 8;
            $(".cursorspecialpointer").css({
                top: t + "px",
                left: e + "px",
            });
        }),
            $(".cursorspecial").mousemove(function (i) {
                var e = i.pageX,
                    t = i.pageY;
                $(".cursorspecialpointer").css({
                    top: t + "px",
                    left: e + "px",
                }),
                    $(".cursorspecialpointer span").addClass(
                        "cursorspecialpointervisible"
                    );
            }),
            $(".cursorspecial").mouseleave(function (i) {
                $(".cursorspecialpointer span").removeClass(
                    "cursorspecialpointervisible"
                );
            });
    }

    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();

    $("body").on("click", ".player", function (e) {
        if (!$(this).hasClass("active")) {
            $(".player")
                .not(this)
                .each(function (index) {
                    $(this).removeClass("active");
                    let audioid = $(this).data("audio");
                    let song = document.getElementById(audioid);
                    song.pause();
                    song.currentTime = 0;
                });
            $(this).addClass("active");
            let audioid = $(this).data("audio");
            let song = document.getElementById(audioid);
            song.play();

            console.log("attivato");
        } else {
            $(this).removeClass("active");
            let audioid = $(this).data("audio");
            let song = document.getElementById(audioid);
            song.pause();
            song.currentTime = 0;
        }
    });

    // selezione opzioni prodotto
    $(".add_product_options").on("change", function () {
        let thisSelectedOptions = $(this).val();
        // aggiorno campo nascosto opzioni prodotto
        $("#opzioniprodotto").val(thisSelectedOptions);
    });

    $(".controlSlide").on("click", function () {
        $(".controlSlide").each(function () {
            $(this).removeClass("selected");
        });
        $(this).addClass("selected");
    });

    $(".comefunziona").on("click", function () {
        let thisMsg = $(this).data("message");
        Swal.fire({
            title: "Come funziona?",
            html: thisMsg,
        }).then((result) => {});
    });

    // filtri apertura modal sweetalert2
    $("body").on("click", ".cosaCerchi", function () {
        $.ajax({
            url: URLASSOLUTO + "/ricerca-libera/",
            method: "GET",
            dataType: "html",
        }).done(function (result) {
            Swal.fire({
                background: "#fff",
                position: "center",
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                    popup: "animated slideInUp faster",
                },
                html: result,
                didOpen: () => {
                    bootstrapvalidation();
                },
            });
        });
    });
    if (VIEWNAME == "frontend.pages.detailTrip") {
        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            StickyFunction();
        };

        // Get the header
        var header = document.getElementById("head");

        // Get the offset position of the navbar
        var sticky = header.offsetTop;

        // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
        function StickyFunction() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }
    }
});

$(window).resize(function () {
    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
});
